import { ColumnDefinitionType } from '@components/molecules/ListTable/ListTable';

import { TableHeader, TableHeaderCell } from './ListTableHeader.styled';

interface ListTableHeaderProps<T extends { id: string }> {
    columns: ColumnDefinitionType<T>[];
}

export const ListTableHeader = <T extends { id: string }>({
    columns,
}: ListTableHeaderProps<T>) => {
    return (
        <TableHeader>
            {columns.map(({ flex, label, minWidth }, index) => (
                <TableHeaderCell flex={flex} key={index} minWidth={minWidth}>
                    {label}
                </TableHeaderCell>
            ))}
        </TableHeader>
    );
};
